import { Component, Input, OnInit } from '@angular/core';
import { SigninService } from '../../authentification/signin/signin.service';
import { UserMission } from 'src/app/authentification/signin/credentials';

@Component({
  selector: 'app-driver-mission-management',
  templateUrl: './driver-mission-management.component.html',
  styleUrls: ['./driver-mission-management.component.css']
})
export class DriverMissionManagementComponent implements OnInit {
  accounts: UserMission[] | null= null;
  loading = false;
  @Input() mode: string; // Declare the 'mode' input property
  @Input() isCollabsed: boolean; // Declare the 'isCollabsed' input property


  constructor(private signinService: SigninService) {
    /**event listner for delete account */
    this.signinService.getUserMissionWasDeleted().subscribe(deletedUser => {
      this.accounts = this.accounts.filter(
        account => account.id !== deletedUser.id
      );
      this.signinService.userMissions = this.accounts;
    });

    /**event listner for create account */
    this.signinService.getUserMissionWasCreated().subscribe(createdUser => {
      this.accounts.unshift(createdUser);
      this.signinService.userMissions = this.accounts;
    });

    /**event listner for update account */
    this.signinService.getUserMissionWasChanged().subscribe(changedUser => {
      for (let i = 0; i < this.signinService.userMissions.length; i++) {
        if (this.signinService.userMissions[i].id === changedUser.id) {
          this.signinService.userMissions[i] = changedUser;
          this.signinService.userMissions[i].vehicules = changedUser.vehicules;
          break;
        }
      }
    });
  }

  ngOnInit() {
    this.loading = true;
    if (this.signinService.userMissions) {
      this.accounts = this.signinService.userMissions;
      this.loading = false;
    } else {
      this.signinService.getUserMissions().subscribe(accounts => {
        this.accounts = accounts;
        this.signinService.userMissions = accounts;
        this.loading = false;
      });
    }
  }
}
